export default {
      id: "info-usage",
      viewBox: "0 0 69 69",
      url: __webpack_public_path__ + "svgs/icons.91fe9319.svg#info",
      toString: function () {
        return this.url;
      }
    }